import { get, post, getStreamText, postStream,getStream } from "./http";

// 首页数据
export const getReportInfoLoop = (params) => get('/api/getReportInfoLoop', params);
// 检测16项详情
export const getReportLoopItem = (params) => post('/api/getReportLoopItem', params);
// 全部数据概览
export const getReportLoopItemAll = (params) => post('/api/getReportLoopItemAll', params);
// 营养素综合详情
export const getReportLoopItemNutritionAll = (params) => post('/api/getReportLoopItemNutritionAll', params);
// 营养素单项详情
export const getReportLoopItemNutrition = (params) => post('/api/getReportLoopItemNutrition', params);
// 调理状态评估
export const getReportInfoCompare = (params) => post('/api/getReportInfoCompare', params);
// 身体内脏单项详情
export const getReportLoopItemOrgans = (params) => post('/api/getReportLoopItemOrgans', params);

// 全部数据概览 v2 版本
export const getReportComprehensiveAll = (params) => post('/api/getReportComprehensiveAll', params);

// 全部调理方案列表
export const getReportConditioningList = (params) => post('/api/getReportConditioningList', params);
// 调理方案详情
export const getReportConditioningInfo = (params) => post('/api/getReportConditioningInfo', params);
// 对比报告详情
export const reportCompareInfoH5 = (params) => post('/api/reportCompareInfoH5', params);
// 新版调理方案详情
export const getReportConditioningInfoH5 = (params) => post('/api/getReportConditioningInfoH5', params);
// 食物来源
export const getReportFoodSource = (params) => get('/api/v1/getNutritionFoodSource', params);
// 解读建议
export const getSuggestion = (params) => get('/api/v1/report/interpret/suggestion', params);

// AI解读整体健康状况流式输出API
export const getReportInterpretStream = (params, abortController,queue) => getStreamText('/api/v1/report/interpret/stream', params, abortController,queue);
export const getReportStream = (params) => getStream('/api/v1/report/interpret/stream/pcm', params);
export const getReportStream1 = (params) => getStream('/api/v1/report/interpret/stream', params);
// AI聊天接口 - 流式输出
// export const postAIChatStream = (formData, abortController, queue) => postFormDataStream('/api/v1/report/interpret/chat/modalities/stream', formData, abortController, queue);
export const postAIChatStream = (formData) => postStream('/api/v1/report/interpret/chat/modalities/stream/pcm', formData);

// 获取关键监测结果和可能受影响的身体体质
export const getReportKeywordData = (params) => get('/api/v1/report/interpret/keyword', params);

// 获取AI聊天历史记录 - 使用测试环境的POST方法
export const getChatHistory = (params) => post('/api/v1/report/interpret/chat/history', params);
export const getRecommendHistory = (params) => get('/api/v1/yyhj/recommend/history', params);
export const getConversationHistory = (params) => get('/api/v1/yyhj/recommend/conversation/history', params);
// js-sdk鉴权
export const wxConfigApi = (url) => get('/api/v1/wechat/js/config', url);
export const conversationApi = (formData) => postStream('/api/v1/yyhj/recommend/conversation', formData);
// 获取模糊推荐产品
export const getFuzzy = (params) => get('/api/v1/yyhj/recommend/fuzzy', params);
